// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5 18C12.5 14.9624 14.9624 12.5 18 12.5C19.5186 12.5 20.895 13.1168 21.8892 14.111C22.8833 15.1052 23.5 16.4816 23.5 18C23.5 21.0376 21.0376 23.5 18 23.5C16.4814 23.5 15.105 22.8832 14.1108 21.889C13.1167 20.8948 12.5 19.5184 12.5 18ZM18 14.5C16.067 14.5 14.5 16.067 14.5 18C14.5 18.6031 14.652 19.17 14.9205 19.6652L19.6654 14.9206C19.1701 14.6521 18.6032 14.5 18 14.5ZM21.0795 16.3348L16.3346 21.0794C16.8299 21.3479 17.3968 21.5 18 21.5C19.933 21.5 21.5 19.933 21.5 18C21.5 17.3969 21.348 16.83 21.0795 16.3348Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.2547 14C11.4638 15.1338 11 16.5128 11 18C11 19.4872 11.4638 20.8662 12.2547 22H2V20C2 16.6863 4.68629 14 8 14H12.2547Z"}}]};

const UserBlockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-blocked-filled',
    ref,
    icon: element,
  },
));

UserBlockedFilledIcon.displayName = 'UserBlockedFilledIcon';

export default UserBlockedFilledIcon;
